/**
 * Default column types from AG Grid
 * @link https://www.ag-grid.com/javascript-data-grid/column-definitions/#provided-column-types
 */
export enum DefaultColumnTypes {
  numericColumn = "numericColumn",
}
